/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  SchemaValidationErrorResponse,
  Shop,
  ShopItems,
  ShopItemsParams,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Shop Detail
 */
export const shop = (
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      slug = toValue(slug);

      return axiosClient<Shop>(
      {url: `/shops/${slug}`, method: 'GET', signal
    },
      );
    }




export const getShopQueryKey = (slug: MaybeRefOrGetter<string>,) => {
    return [
    'shops',slug
    ] as const;
    }


export const getShopQueryOptions = <TData = Awaited<ReturnType<typeof shop>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shop>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getShopQueryKey(slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof shop>>> = ({ signal }) => shop(slug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(slug) !== null && toValue(slug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof shop>>, TError, TData>
}

export type ShopQueryResult = NonNullable<Awaited<ReturnType<typeof shop>>>
export type ShopQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Shop Detail
 */

export function useShop<TData = Awaited<ReturnType<typeof shop>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shop>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShopQueryOptions(slug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Shop Items
 */
export const shopItems = (
    slug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ShopItemsParams>,
 signal?: AbortSignal
) => {
      slug = toValue(slug);
params = toValue(params);

      return axiosClient<ShopItems>(
      {url: `/shops/${slug}/items`, method: 'GET',
        params, signal
    },
      );
    }




export const getShopItemsQueryKey = (slug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ShopItemsParams>,) => {
    return [
    'shops',slug,'items', ...(params ? [params] : [])
    ] as const;
    }


export const getShopItemsQueryOptions = <TData = Awaited<ReturnType<typeof shopItems>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(slug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ShopItemsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopItems>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getShopItemsQueryKey(slug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof shopItems>>> = ({ signal }) => shopItems(slug,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(slug) !== null && toValue(slug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof shopItems>>, TError, TData>
}

export type ShopItemsQueryResult = NonNullable<Awaited<ReturnType<typeof shopItems>>>
export type ShopItemsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Shop Items
 */

export function useShopItems<TData = Awaited<ReturnType<typeof shopItems>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 slug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<ShopItemsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopItems>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShopItemsQueryOptions(slug,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






